import axios from "axios";
const base_uri = process.env.REACT_APP_API_URL;
console.log(base_uri,'base_uri')
export const ApiCall = async (
  header,
  subUri,
  body = null,
  method = "POST",
  base = base_uri
) => {
  const config = {
    method,
    url: `${base}${subUri}`,
    headers: header,
    data: method.toLowerCase() !== "get" ? body : undefined,
  };
  try {
    const response = await axios(config);
    return response;
  } catch (error) {
    return error;
  }
};

export const show_error = (error) => {
  return (
    error?.response?.data?.error ||
    error?.response?.data?.message ||
    error?.message ||
    "An error occured"
  );
};
